import { ALL_ID } from '@/components/discovery-filter/constants';

import type { PowerType } from './types';
import { type Dispatch } from '@/app-state/store';

type UpdatePowerTypeStateParams = {
  selectedPowerTypes: PowerType[];
  powerType: PowerType;
  filterActions: Pick<Dispatch['filters'], 'updatePowerTypes' | 'removePowerType' | 'addPowerType'>;
};

export const updatePowerTypeState = ({ selectedPowerTypes, powerType, filterActions }: UpdatePowerTypeStateParams) => {
  if (powerType === ALL_ID) {
    return filterActions.updatePowerTypes([]);
  }
  if (selectedPowerTypes.includes(powerType)) {
    return filterActions.removePowerType(powerType);
  }

  filterActions.addPowerType(powerType);
};
